/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  area_division_id: z.number(),
  slot: z.number(),
  label_name: z.string(),
  is_required: z.boolean(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
  slot: base.shape.slot.optional(),
  label_name: base.shape.label_name.optional(),
  is_required: base.shape.is_required.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const AreaDivisionLocationLabelBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type AreaDivisionLocationLabelBase = z.infer<typeof base>;
export type AreaDivisionLocationLabelBasePutPayload = z.infer<typeof put>;
export type AreaDivisionLocationLabelBasePatchPayload = z.infer<typeof patch>;
export type AreaDivisionLocationLabelBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type AreaDivisionLocationLabelBaseCreateAttributes = z.infer<typeof create>;
export type AreaDivisionLocationLabelBaseUpdateAttributes = z.infer<typeof update>;
export type AreaDivisionLocationLabelBaseCacheAttributes = z.infer<typeof cache>;
export type AreaDivisionLocationLabelBaseCachesAttributes = z.infer<typeof caches>;